import { createSlice } from "@reduxjs/toolkit";
import {
  enableOrDisableOrgCode,
} from "../../actions/settings/settingsData";

const initialState = {
  orgCodeEnabled: false,
  isOrgCodeLoading: true,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    settings: (state, { payload }) => {},
  },
  extraReducers: {
    [enableOrDisableOrgCode.pending]: (state) => {
      state.isOrgCodeLoading = true;
    },
    [enableOrDisableOrgCode.fulfilled]: (state, { payload }) => {
      state.orgCodeEnabled = payload?.org_code_status
        ? payload?.org_code_status === 1
          ? true
          : false
        : false;
      state.isOrgCodeLoading = false;
    },
    [enableOrDisableOrgCode.rejected]: (state, { payload }) => {
      state.isOrgCodeLoading = false;
    },
  },
});

export const { settings } = settingsSlice.actions;

export default settingsSlice.reducer;
